import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class StateService {
    static async getAllStates(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.STATES; //endpoint
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        }
        else {
            console.error('Failed to fetch states.');
            return [];
        }
    }

    // Create
    static async addNewState(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.STATES; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('State added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new state.');
        }
    }


    // Get by ID
    static async getStateById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.STATES}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch state by ID');
        }
    }

    // Update 
    static async updateStateById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.STATES}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('State updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update state.');
        }
    }


    // Delete 
    static async deleteState(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.STATES}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete vendor data.');
            }
        } catch (error) {
            console.error('Error deleting vendor data:', error);
            throw error;
        }
    }

    // Delete  by IDs
    static async deleteManyStates(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.STATES}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
